export default {
  changeLang (state) {
    const lang = require('@/locale/' + state.current)
    state.lang = lang
  },

  setCurrent (state, current) {
    state.current = current
  },

  setUserLocale (state, userLocale) {
    state.userLocale = userLocale
  }
}
